import React from 'react';

// Top-level error boundary so a render-time exception never produces a blank
// WebView. Without this, any throw inside the React tree on first mount
// (e.g., a WebKit-specific quirk on iPad) would unmount the whole app and
// leave the user staring at the launch screen background — which is exactly
// how Apple's reviewer rejected v1.0.0 (1).
export class RootErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Best-effort logging. Do not throw from here.
    try {
      // eslint-disable-next-line no-console
      console.error('[RootErrorBoundary]', error, info?.componentStack);
    } catch {}
  }

  reset = () => {
    this.setState({ error: null });
  };

  render() {
    if (this.state.error) {
      const msg = this.state.error?.message || String(this.state.error);
      return (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: '#0a0d12',
            color: '#eaecef',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px',
            textAlign: 'center',
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "SF Pro Text", "Helvetica Neue", Arial, sans-serif',
          }}
        >
          <div style={{ fontSize: 28, fontWeight: 300, letterSpacing: '0.02em', marginBottom: 16 }}>
            Consistency
          </div>
          <div style={{ fontSize: 15, opacity: 0.75, maxWidth: 320, lineHeight: 1.5 }}>
            Something went wrong while loading. Try reopening the app.
          </div>
          <button
            type="button"
            onClick={this.reset}
            style={{
              marginTop: 24,
              padding: '10px 22px',
              borderRadius: 999,
              border: '1px solid rgba(255,255,255,0.18)',
              background: 'rgba(255,255,255,0.06)',
              color: '#eaecef',
              fontSize: 14,
              cursor: 'pointer',
            }}
          >
            Try again
          </button>
          <div
            style={{
              marginTop: 20,
              fontSize: 11,
              opacity: 0.4,
              maxWidth: 320,
              wordBreak: 'break-word',
            }}
          >
            {msg}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
